import cn from "classnames";
import { default as ReactModal } from "react-modal";

import i from "@styles/icons.module.scss";
import Divider from "@ui-kit/Divider/Divider";

import s from "./Modal.module.scss";

const Modal = ({
  className,
  children,
  withCustomCloseButton = false,
  onRequestClose,
  isShowDivider = true,
  ...props
}) => {
  return (
    <ReactModal
      {...props}
      onRequestClose={onRequestClose}
      className={cn(s.content, className)}
      overlayClassName={s.overlayClassName}
      //   onAfterOpen={
      //     handleAfterOpenFunc
      //     /* Function that will be run after the modal has opened. */
      //   }
      // onAfterClose={
      // TODO: remove get param modal from url
      // handleAfterCloseFunc
      /* Function that will be run after the modal has closed. */
      // }
      //   onRequestClose={
      //     handleRequestCloseFunc
      //     /* Function that will be run when the modal is requested
      //  to be closed (either by clicking on overlay or pressing ESC).
      //  Note: It is not called if isOpen is changed by other means. */
      //   }
    >
      <div className={s.modalContainer}>
        {!withCustomCloseButton && onRequestClose && (
          <icon className={cn(i.close, s.close)} onClick={onRequestClose} />
        )}

        <div className={s.modalContent}>{children}</div>

        {isShowDivider && (
          <div className={s.brandStrip}>
            <Divider height={3} absolute className={s.divider} />
          </div>
        )}
      </div>
    </ReactModal>
  );
};

export default Modal;
